import React, { useContext, useEffect, useState } from "react";
import "./fleetPage.css";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {
  carsApi,
  keysApi,
  searchApi,
  siteValuesApi,
} from "../../api/GardenoApi";
import { convertToLanguage } from "../../utils/generalUtils";
import { ClientContext } from "../../../store/context";
import Filters from "./Filters";
import Datebox from "../../components/Datebox";
import VehicleCards from "./VehicleCards";
import { Post } from "../../api/ApiCallerService";
import { Alert, Box, Button, IconButton, Slide } from "@mui/material";
import TemporaryDrawer from "./MobileFilters";
import { vehicleValues } from "../../utils/constants";
import { usePost } from "../../hooks/Hooks";

function FleetPage() {
  const { language, pickUpDate, dropOffDate,} =
    useContext(ClientContext);
  const [cars, setCars] = useState();
  const [filteredCars, setFilteredCars] = useState(null);
  const [error, setError] = useState();

  const [filters, setFilters] = useState({
    FUEL: [],
    LUGGAGE: [],
    TRANSMISSION: [],
  });
  const [appliedFilters, setAppliedFilters] = useState({
    FUEL: [],
    LUGGAGE: [],
    TRANSMISSION: [],
  });
  const createFilters = (cars) => {
    let tempFilters = {
      FUEL: [],
      LUGGAGE: [],
      TRANSMISSION: [],
    };
    cars?.forEach((car) => {
      if (!tempFilters.FUEL.includes(car.traitMap?.FUEL)) {
        tempFilters.FUEL = [...tempFilters.FUEL, car?.traitMap?.FUEL];
      }
      if (!tempFilters.LUGGAGE.includes(car.traitMap?.LUGGAGE)) {
        tempFilters.LUGGAGE = [...tempFilters.LUGGAGE, car?.traitMap?.LUGGAGE];
      }
      if (!tempFilters.TRANSMISSION.includes(car.traitMap?.TRANSMISSION)) {
        tempFilters.TRANSMISSION = [
          ...tempFilters.TRANSMISSION,
          car?.traitMap?.TRANSMISSION,
        ];
      }
    });
    setFilters(tempFilters);
  };
  useEffect(() => {
    if (pickUpDate && dropOffDate) {
      Post(
        searchApi.post(
          pickUpDate.format("YYYY-MM-DD"),
          dropOffDate.format("YYYY-MM-DD")
        ),
        convertToLanguage(language),
        {}
      )
        .then((response) => {
          switch (response.status) {
            case 200:
              response.json().then((args) => {
                setCars(args["result"]["data"]);
                createFilters(args["result"]["data"]);
              });

              break;

            default:
              setError(true);
              break;
          }
        })
        .catch((error) => {
          setError(true);
        });
    } else {
      Post(carsApi.getAllCars, convertToLanguage(language), {})
        .then((response) => {
          switch (response.status) {
            case 200:
              response.json().then((args) => {
                setCars(args["result"]["data"]);
                createFilters(args["result"]["data"]);
              });

              break;

            default:
              setError(true);
              break;
          }
        })
        .catch((error) => {
          setError(true);
        });
    }
  }, [language]);

  const [settings, settigsError] = usePost(
    keysApi.getAllKeys,
    convertToLanguage(language),
    vehicleValues
  );
  return (
    <div className="fleet-page-content">
      <Box
        className="fleet-page-dateBox"
        sx={{ width: { xs: "96%", lg: "60%" } }}
      >
        <Datebox
          onSearchClick={() =>
            Post(
              searchApi.post(
                pickUpDate.format("YYYY-MM-DD"),
                dropOffDate.format("YYYY-MM-DD")
              ),
              convertToLanguage(language),
              {}
            )
              .then((response) => {
                switch (response.status) {
                  case 200:
                    response.json().then((args) => {
                      setCars(args["result"]["data"]);
                      createFilters(args["result"]["data"]);
                    });

                    break;

                  default:
                    setError(true);
                    break;
                }
              })
              .catch((error) => {
                setError(true);
              })
          }
        />
      </Box>
      <Box
        className="fleet-page-cars"
        sx={{
          width: { xs: "96%", lg: "60%" },
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box sx={{ display: { xs: "none", sm: "flex" } }}>
          <Filters
            cars={cars}
            filters={filters}
            appliedFilters={appliedFilters}
            setFilteredCars={setFilteredCars}
            setAppliedFilters={setAppliedFilters}
            settings={settings?.settings}
          />
        </Box>
        <Box sx={{ display: { md: "none", xs: "flex" } }}>
          <TemporaryDrawer>
            <Filters
              cars={cars}
              filters={filters}
              appliedFilters={appliedFilters}
              setFilteredCars={setFilteredCars}
              setAppliedFilters={setAppliedFilters}
              settings={settings?.settings}
            />
          </TemporaryDrawer>
        </Box>
        <VehicleCards cars={filteredCars} settings={settings?.settings} />
      </Box>
    </div>
  );
}

export default FleetPage;
